import {
  CHARGING_STRATEGIES,
  DURATION_POLICIES,
  PARTICIPATION_STRATEGIES,
  PAYMENT_STRATEGIES,
  SCHEDULE_ITEM_STATUSES,
} from "./billingEnrollmentTypes";

const hasValue = value => value !== undefined && value !== null && String(value).trim() !== "";
const includesValue = (values, value) => Object.values(values).includes(value);
const isPositiveInteger = value => Number.isInteger(Number(value)) && Number(value) > 0;

export function validateProduct(product = {}) {
  const errors = {};

  if (!hasValue(product.name)) errors.name = "Nazwa produktu jest wymagana.";
  if (!includesValue(PARTICIPATION_STRATEGIES, product.participationStrategy)) {
    errors.participationStrategy = "Strategia uczestnictwa jest wymagana.";
  }
  if (!includesValue(PAYMENT_STRATEGIES, product.paymentStrategy)) {
    errors.paymentStrategy = "Strategia platnosci jest wymagana.";
  }
  if (!includesValue(CHARGING_STRATEGIES, product.chargingStrategy)) {
    errors.chargingStrategy = "Strategia naliczania jest wymagana.";
  }
  if (!includesValue(DURATION_POLICIES, product.durationPolicy)) {
    errors.durationPolicy = "Polityka czasu trwania jest wymagana.";
  }
  if (product.chargingStrategy === CHARGING_STRATEGIES.CONSUME_PACKAGE_UNITS) {
    if (!hasValue(product.packageUnits)) {
      errors.packageUnits = "Liczba lekcji w pakiecie jest wymagana.";
    } else if (!isPositiveInteger(product.packageUnits)) {
      errors.packageUnits = "Liczba lekcji w pakiecie musi byc dodatnia liczba calkowita.";
    }
    if (!hasValue(product.classTypeId)) {
      errors.classTypeId = "Typ lekcji jest wymagany.";
    }
  }

  return errors;
}

function selectedStudentIds(enrollment = {}) {
  const studentIds = enrollment.studentIds || [];
  const eligibleStudentIds = enrollment.eligibleStudentIds || [];
  return studentIds.length > 0 ? studentIds : eligibleStudentIds;
}

export function validateEnrollment(enrollment = {}) {
  const errors = {};
  const product = enrollment.product || enrollment.termsSnapshot || {};
  const students = selectedStudentIds(enrollment);
  const eligibleStudentIds = enrollment.eligibleStudentIds || [];

  if (!hasValue(enrollment.clientId)) errors.clientId = "Klient jest wymagany.";
  if (!hasValue(enrollment.startDate)) errors.startDate = "Data rozpoczecia jest wymagana.";
  if (!hasValue(product.id)) errors.productId = "Produkt jest wymagany.";

  if (product.participationStrategy === PARTICIPATION_STRATEGIES.SINGLE_STUDENT && students.length !== 1) {
    errors.studentIds = "Ten produkt wymaga dokladnie jednego studenta.";
  }

  if (product.participationStrategy === PARTICIPATION_STRATEGIES.SINGLE_STUDENT && eligibleStudentIds.length > 0) {
    errors.eligibleStudentIds = "Ten produkt nie obsluguje wspoldzielonych studentow.";
  }

  if (product.participationStrategy === PARTICIPATION_STRATEGIES.SHARED_STUDENTS && students.length < 1) {
    errors.eligibleStudentIds = "Ten produkt wymaga przynajmniej jednego uprawnionego studenta.";
  }

  return errors;
}

export function buildPaymentScheduleItems({ enrollmentId, items = [] }) {
  return items.map((item, index) => ({
    id: `${enrollmentId}#${item.dueDate}#${item.sourceType}#${index + 1}`,
    dueDate: item.dueDate,
    amount: Number(item.amount || 0),
    sourceType: item.sourceType,
    description: item.description || "",
    status: item.status || SCHEDULE_ITEM_STATUSES.PLANNED,
  }));
}

export function getScheduleItemDueState(item, today) {
  if (item.status && item.status !== SCHEDULE_ITEM_STATUSES.PLANNED) {
    return item.status;
  }

  return item.dueDate <= today ? "due" : "future";
}
